import React, { useState, useEffect, useRef } from "react";

// material ui
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormGroup from "@material-ui/core/FormGroup";
import RadioGroup from "@material-ui/core/RadioGroup";
import Radio from "@material-ui/core/Radio";

import useStyles from "./styles";

import chunk from "lodash/chunk";

import validation from "../validation";

import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import ChevronRight from "@material-ui/icons/ChevronRight";
import ChevronLeft from "@material-ui/icons/ChevronLeft";

import InfoButton from "../../../../../components/InfoButton";

function SubFormNumber({
  id,
  setValue,
  saveValue,
  saveChangeValue,
  value,
  form,
  wilayah,
  keluarga,
  handleBackSub,
  navigationMode,
  isSingle,
  setIsSingle,
  subformIndex,
  direction,
  backRadio,
  isSubmitting,
  pk,
}) {
  const nextRef = useRef(null);
  const backRef = useRef(null);

  const classes = useStyles();
  const [error, setError] = useState({});

  const [berlaku, setBerlaku] = useState(false);
  const [disJawabanA, setDisJawabanA] = useState();
  // value.jawabanA === "2" &&
  //   (value.jawaban === "6" || value.jawaban === "7" || value.jawaban === "8")

  const [jawaban, setJawaban] = useState(value.jawaban || "");
  const [jawabanA, setJawabanA] = useState(value.jawabanA || "");
  const [jwbLain, setJwbLain] = useState(value.jawaban_lainnya || "");
  const [kondisi, setKondisi] = useState(value.kondisi || 0);

  useEffect(() => {
    setError({});
  }, []);

  useEffect(() => {
    let valIndex = 0;
    if (
      wilayah.status_draft == 1 &&
      wilayah.pos_draft == 3 &&
      wilayah.subformIndex !== undefined
    ) {
      valIndex = wilayah.subformIndex;
      if (value.jawaban !== undefined) {
        // handleSubmit(null)
        console.log("next nya neeeh ::: ");
        // console.log("subformIndex nya neeeh : " , subformIndex)
      }
    }

    // console.log(direction, "DIRECTION");
    if (form.dependencies.length <= 0) {
      setBerlaku(true);
    } else {
      const valuesKel = Object.values(keluarga);
      const cekberlaku = form.dependencies.some((dep) => {
        return validation[dep](valuesKel);
      });

      let normalizeValue;
      if (!cekberlaku) {
        setValue({ target: { name: "jawaban", value: "3" } });

        if (direction.navigate === "right") {
          console.log("radio : run right function");
          if (value.jawaban === undefined || value.jawaban === "3") {
            console.log(
              "radio : run right undefined | value jawaban = 3 function"
            );
            normalizeValue = {
              Pertanyaan: pertanyaan,
              Jawab_Pilih: "3",
              Jawaban_H1: value.kondisi || 0,
              Jawaban_H2: 0,
              No_Pertanyaan: parseInt(form.no),
              Lainnya: value.jawaban_lainnya || "",
            };

            if (value._rev) {
              normalizeValue._rev = value._rev;
            }

            saveValue(normalizeValue);
          }
        } else if (direction.navigate === "left") {
          if (value.jawaban === "3") {
            backRadio(cekberlaku);
          }
        }
      }
      setBerlaku(cekberlaku);
    }

    // console.log("direction : ", direction)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, form]);

  const { pertanyaan, definisi_operasional, sub_definisi_operasional } = form;

  // useEffect(() => {
  //   if (value.jawabanA !== undefined && value.jawabanA !== jawabanA) {
  //     setJawabanA(value.jawabanA);
  //   }
  // }, [value]);

  const handleChange = (e) => {
    setValue(e);
    setDisJawabanA(false);

    setError({
      ...error,
      [e.target.name]: "",
    });
    switch (e.target.name) {
      case "jawaban":
        setJawaban(e.target.value);
        setJawabanA("");
        // setValue({ target: { name: "jawabanA", value: "" } });
        // setError({
        //   ...error,
        //   jawabanA: "",
        // });
        break;
      case "jawabanA":
        setJawabanA(e.target.value);
        break;
      default:
        break;
    }
    // setSomethingChange(true)
  };

  useEffect(() => {
    let normalizeValue = {
      Pertanyaan: pertanyaan,
      Jawab_Pilih: jawaban,
      Jawaban_H1: kondisi || 0,
      Jawaban_H2: 0,
      No_Pertanyaan: parseInt(form.no),
      Lainnya: jwbLain || "",
      Pertanyaan2: "Kondisi dinding",
      Jawab_Pilih2: jawabanA,
      No_Pertanyaan2: "18.2",
    };

    if (value._rev) {
      normalizeValue._rev = value._rev;
    }

    //console.log("save change radio => ", normalizeValue)

    saveChangeValue(normalizeValue);
  }, [jawaban, jawabanA, jwbLain, kondisi]);

  const validate = () => {
    let newError = {};

    if (!value.jawaban) {
      newError.jawaban = "Wajib diisi";
    }

    if (!value.jawabanA) {
      newError.jawabanA = "Wajib diisi";
    }

    return newError;
  };

  const handleSubmit = (e) => {
    if (e !== null) {
      e.preventDefault();
    }

    const findErrors = validate();
    const errorValues = Object.values(findErrors);

    if (errorValues.length > 0 && errorValues.some((err) => err !== "")) {
      setError(findErrors);
    } else {
      let normalizeValue = {
        Pertanyaan: pertanyaan,
        Jawab_Pilih: value.jawaban,
        Jawaban_H1: value.kondisi || 0,
        Jawaban_H2: 0,
        No_Pertanyaan: parseInt(form.no),
        Lainnya: value.jawaban_lainnya || "",
        Pertanyaan2: "Kondisi dinding",
        Jawab_Pilih2: jawabanA,
        No_Pertanyaan2: "18.2",
      };
      if (value._rev) {
        normalizeValue._rev = value._rev;
      }
      saveValue(normalizeValue);
    }
  };

  //   const option_cb = ["Bagus/kualitas tinggi", "Jelek/kualitas rendah"];
  const option_cb = ["Baik", "Rusak Ringan", "Rusak Berat"];

  return (
    <>
      <form id={id} onSubmit={handleSubmit} noValidate>
        <div className={classes.card}>
          <div className={classes.cardHeader}>
            <Typography margin="normal" paragraph>
              <span className={classes.badge}>{form.no}</span>
              {pertanyaan}
            </Typography>
            <div style={{ position: "absolute", right: "0", top: "58px" }}>
              <InfoButton
                title={`Pertanyaan ${form.no}`}
                content={form.definisi_operasional}
              />
            </div>
          </div>
          <div className={classes.cardBody}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <FormControl
                  error={error.jawaban ? true : false}
                  component="fieldset"
                >
                  <RadioGroup
                    value={value.jawaban || ""}
                    onChange={handleChange}
                    aria-label="jawaban"
                    name="jawaban"
                  >
                    {form.options.map((option, index) => {
                      let disabled = false;
                      return (
                        <FormControlLabel
                          disabled={disabled}
                          key={index}
                          control={<Radio />}
                          value={`${index + 1}`}
                          label={`${index + 1}. ${option}`}
                        />
                      );
                    })}
                  </RadioGroup>
                  <FormHelperText>{error.jawaban}</FormHelperText>
                </FormControl>
              </Grid>
            </Grid>
          </div>
        </div>
        <div className={classes.card}>
          <div className={classes.cardHeader}>
            <Typography margin="normal" paragraph>
              <span className={classes.badge}>18.2</span>Kondisi dinding:
            </Typography>
          </div>
          <div className={classes.cardBody}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <FormControl
                  error={error.jawabanA ? true : false}
                  component="fieldset"
                >
                  <RadioGroup
                    value={value.jawabanA || ""}
                    onChange={handleChange}
                    aria-label="jawabanA"
                    name="jawabanA"
                  >
                    {option_cb.map((option, index) => {
                      return (
                        <FormControlLabel
                          disabled={disJawabanA}
                          key={index}
                          control={<Radio />}
                          value={`${index + 1}`}
                          label={`${index + 1}. ${option}`}
                        />
                      );
                    })}
                  </RadioGroup>
                  <FormHelperText>{error.jawabanA}</FormHelperText>
                </FormControl>
              </Grid>
            </Grid>
          </div>
        </div>
      </form>

      <Grid item xs style={{ marginTop: 20 }}>
        <Button
          ref={backRef}
          // disabled={!isSomethingChange || isSubmitting}
          onClick={handleBackSub}
        >
          <ChevronLeft className={classes.iconLeft} /> Sebelumnya{" "}
        </Button>

        {isSubmitting && <CircularProgress size={14} />}
        <Button
          style={{ float: "right" }}
          ref={nextRef}
          form={id}
          disabled={isSubmitting}
          type="submit"
        >
          {subformIndex >= 31 ||
          (subformIndex === 30 && pk["0231"] && pk["0231"].jawaban === "2")
            ? "Selanjutnya"
            : "Selanjutnya"}{" "}
          <ChevronRight className={classes.iconRight} />
        </Button>
      </Grid>
    </>
  );
}

export default SubFormNumber;
